import { useState } from 'react'

import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    footer: {
      submit: (creating: boolean) =>
        creating
          ? translate({ id: 'setup.depots.edit.createDepot' })
          : translate({ id: 'setup.depots.edit.saveDepot' }),
      cancel: translate({ id: 'global.cancel' }),
    },
    validation: {
      name: translate({ id: 'setup.depots.form.errors.name' }),
      setupCost: translate({ id: 'setup.depots.form.errors.setupCost' }),
      setupTime: translate({ id: 'setup.depots.form.errors.setupTime' }),
      title: translate({ id: 'setup.depots.form.formErrorsTitle' }),
      location: translate({ id: 'setup.depots.form.errors.location' }),
    },
    fields: {
      name: translate({ id: 'setup.depots.fields.depotName' }),
      nameInfo: translate({ id: 'setup.depots.fields.depotNameInfo' }),
      setupCost: translate({ id: 'setup.depots.fields.setupCost' }),
      setupCostHelper: translate({ id: 'setup.depots.fields.setupCost.helper' }),
      setupTime: translate({ id: 'setup.depots.fields.setupTime' }),
      setupTimeHelper: translate({ id: 'setup.depots.fields.setupTime.helper' }),
      location: translate({ id: 'setup.depots.fields.location' }),
      locationHelper: translate({ id: 'setup.depots.fields.location.helper' }),
      locationPlaceholder: translate({ id: 'setup.depots.fields.location.placeholder' }),
      color: translate({ id: 'setup.depots.fields.color.title' }),
      colorInfo: translate({ id: 'setup.depots.fields.color.info' }),
      cannotEditField: translate({ id: 'setup.depots.fields.cannotEditField' }),
    },
    title: translate({ id: 'setup.depots.edit.title' }),
  }))

  return api
}
